{
  "zh-TW": {
    "nav": {
      "raffles": "抽獎",
      "raffle": "抽獎",
      "admin": {
        "raffles": {
          "index": "抽獎",
          "new": "新增抽獎",
          "edit": "編輯抽獎",
          "entries": "抽獎參加紀錄"
        }
      },
      "raffleClaim": "領取獎品",
      "settings": {
        "raffles": "我的抽獎"
      }
    },
    "title": {
      "raffles": "抽獎",
      "raffle": "抽獎",
      "admin": {
        "raffles": {
          "index": "抽獎",
          "new": "新增抽獎",
          "edit": "編輯抽獎",
          "entries": "抽獎參加紀錄"
        }
      },
      "raffleClaim": "領取獎品",
      "settings": {
        "raffles": "我的抽獎"
      }
    },
    "headlines": {
      "admin": {
        "raffles": {
          "index": "抽獎",
          "new": "新增抽獎",
          "edit": "編輯抽獎",
          "entries": "抽獎參加紀錄"
        }
      },
      "settings": {
        "raffles": "我的抽獎"
      }
    },
    "labels": {
      "raffle": {
        "title": "標題",
        "prize": "獎品",
        "prizeInfo": "得獎者獲得的獎品，顯示在抽獎旁邊。發布時必填。",
        "description": "描述",
        "descriptionInfo": "Markdown。將艦船或物品寫成 [*名稱*] 即可連結；輸入 [* 進行搜尋。",
        "translationInfo": "選填。留空的欄位將顯示英文內容。",
        "importFolderInfo": "從一個資料夾一次填寫所有語言和圖庫：每種語言一個 en.md、de.md……，在 front matter 區塊中寫標題和獎品，另附圖片。按下儲存之前不會儲存任何內容。",
        "imagesUploading": "正在上傳圖片：%{count}",
        "code": "禮品碼",
        "codeInfo": "得獎者獲得的禮品碼。它會加密儲存，且不會再完整顯示。",
        "codeSet": "已設定禮品碼（%{code}）。將此欄位留空即可保留。",
        "codeFrozen": "開獎後無法再變更禮品碼。",
        "startsAt": "開始時間",
        "endsAt": "截止時間",
        "claimPeriodDays": "領取期限（天）",
        "claimPeriodDaysInfo": "得獎者點擊領取郵件中連結的時限，逾期後得獎資格將順延給下一位。",
        "published": "已發布",
        "publishedInfo": "只有已發布的抽獎才會被列出並開放參加。發布前需要設定禮品碼。",
        "status": "狀態",
        "entriesCount": "參加數",
        "entriesCountValue": "參加數：%{count}",
        "statuses": {
          "draft": "草稿",
          "upcoming": "即將開始",
          "open": "進行中",
          "closed": "已截止",
          "drawn": "已開獎",
          "concluded": "已結束"
        },
        "drawnInfo": "已開獎",
        "drawnBy": "由 %{admin} 於 %{date} 開獎。",
        "currentWinner": "目前得獎者：%{username}",
        "claimDeadline": "領取截止：%{date}",
        "runDays": "持續時間（天）",
        "runDaysInfo": "抽獎從開始起開放參加的天數。",
        "images": "圖片",
        "imagesInfo": "第一張圖片將作為卡片和首頁上的封面。",
        "cover": "封面",
        "socialPosts": "X 貼文",
        "claimedInfo": "於 %{date} 領取。禮品碼郵件：%{mail}。",
        "claimPending": "領取連結已寄至 %{email}（%{mail}）。領取期限於 %{date} 結束。",
        "overview": {
          "title": "概覽",
          "prize": "獎品",
          "code": "禮品碼",
          "noCode": "未設定",
          "startsAt": "開始",
          "endsAt": "結束",
          "runDays": "持續時間",
          "claimPeriodDays": "領獎期限",
          "days": "%{days} 天",
          "startAnnouncedAt": "開始通知",
          "lastDayAnnouncedAt": "最後一天提醒",
          "drawnAt": "已開獎",
          "drawnBy": "%{date}，由 %{admin}",
          "concludedAt": "已結束",
          "publicPage": "開啟公開頁面",
          "noImages": "尚無圖片。發布需要至少一張。",
          "previewInfo": "一個連結，任何持有者都能檢視此抽獎（包括草稿），無需帳號。有效期 30 天。",
          "copyPreview": "複製預覽連結",
          "openPreview": "開啟預覽"
        }
      },
      "raffleEntry": {
        "username": "參加者",
        "drawPosition": "順位",
        "conditionsAcceptedAt": "已接受條款",
        "state": "狀態",
        "accountDeleted": "帳戶已刪除",
        "states": {
          "claimed": "已領取",
          "forfeited": "已失效",
          "passedOver": "已順延",
          "winner": "得獎者",
          "waiting": "候補中",
          "notDrawn": "不符合資格"
        },
        "mail": "郵件",
        "claimMail": "領取郵件",
        "prizeMail": "禮品碼郵件",
        "mailStatuses": {
          "sent": "已寄出",
          "delivered": "已送達",
          "bounced": "已退回"
        },
        "warnings": "警告",
        "warningLabels": {
          "sharedIp": "相同 IP",
          "sameInbox": "相同信箱",
          "newAccount": "新帳戶",
          "noEmail": "無電子郵件"
        },
        "warningDetails": {
          "sharedIp": "與以下使用者登入 IP 相同：%{usernames}。常見於同一家庭或行動網路。",
          "sameInbox": "與以下使用者電子郵件信箱相同：%{usernames}。很可能是同一個人。",
          "newAccount": "帳戶建立不到一天後即參加。",
          "noEmail": "帳戶沒有電子郵件地址。抽獎時將被略過。"
        }
      },
      "admin": {
        "resourceAccess": {
          "privileges": {
            "raffles": "抽獎"
          }
        }
      },
      "notificationTypes": {
        "raffle_won": "抽獎得獎",
        "raffle_started": "抽獎已開始",
        "raffle_last_day": "抽獎即將截止",
        "raffle_email_missing": "參加抽獎需要電子郵件地址"
      }
    },
    "placeholders": {
      "raffle": {
        "title": "贏得一艘 Polaris",
        "description": "獎品內容及參加方式",
        "code": "XXXX-XXXX-XXXX",
        "claimPeriodDays": "3",
        "runDays": "14",
        "prize": "Anvil Polaris 遊戲包"
      }
    },
    "messages": {
      "raffle": {
        "created": "抽獎已建立。",
        "updated": "抽獎已更新。",
        "destroyed": "抽獎已刪除。",
        "createFailed": "無法建立抽獎。",
        "updateFailed": "無法更新抽獎。",
        "drawn": "已開獎。",
        "drawFailed": "無法開獎。",
        "invalid": "請檢查標示的欄位：抽獎需要標題、開始時間和持續時間。",
        "imported": "資料夾已匯入（語言：%{languages}，圖片：%{images}）。請檢查表單後儲存。",
        "importSkipped": "已略過的檔案：%{files}",
        "importEmpty": "該資料夾中既沒有語言檔案也沒有圖片。",
        "importUploadFailed": "以下圖片無法上傳：%{files}"
      },
      "confirm": {
        "raffle": {
          "destroy": "確定要刪除此抽獎嗎？此操作無法復原。",
          "draw": "現在開獎嗎？所有參加者的順序將永久確定，且無法重新抽取。"
        }
      }
    },
    "actions": {
      "raffle": {
        "entries": "參加紀錄",
        "draw": "開獎",
        "importFolder": "匯入資料夾"
      }
    },
    "raffles": {
      "title": "抽獎",
      "lead": "贏得 Star Citizen 艦船的禮品碼。參加進行中的抽獎；抽獎截止後，將隨機抽出得獎者。",
      "empty": "目前沒有抽獎活動。",
      "status": "狀態",
      "runs": "活動期間",
      "endsAt": "%{date} 截止",
      "entriesCount": "參加者：%{count}",
      "entered": "您已參加此抽獎。",
      "statuses": {
        "draft": "草稿",
        "upcoming": "即將開始",
        "open": "進行中",
        "closed": "已截止，等待開獎",
        "drawn": "已開獎",
        "concluded": "已結束"
      },
      "entrants": {
        "title": "參加者",
        "empty": "還沒有人參加。",
        "count": "參加者",
        "titleCount": "參加者 · %{count}",
        "showAll": "顯示全部 %{count} 位"
      },
      "winner": {
        "title": "得獎者",
        "pending": "%{username} 得獎了，需在 %{date} 前領取禮品碼。",
        "claimed": "%{username} 得獎了，並已領取禮品碼。",
        "forfeited": "未按時領取",
        "claimedPill": "已領取",
        "until": "截至 %{date}",
        "drawnOn": "已於 %{date} 從 %{count} 位參加者中抽出。"
      },
      "over": {
        "title": "本次抽獎已結束",
        "closed": "報名已截止，即將抽出得獎者。",
        "drawn": "報名已截止，得獎者已抽出。",
        "concluded": "本次抽獎已結束，感謝所有參加者。"
      },
      "won": {
        "title": "您得獎了！",
        "checkMail": "我們已寄給您一封郵件，其中包含領取獎品的連結。請在 %{date} 前點擊該連結，否則得獎資格將順延給下一位。",
        "claimed": "獎品已領取",
        "codeSent": "您的禮品碼正在寄送到您的信箱。"
      },
      "actions": {
        "enter": "參加抽獎",
        "withdraw": "退出",
        "signInToEnter": "登入後參加此抽獎",
        "addEmail": "新增電子郵件地址"
      },
      "messages": {
        "entered": "您已參加抽獎。祝您好運！",
        "withdrawn": "您已退出抽獎。",
        "confirmWithdraw": "退出此抽獎？",
        "forbidden": "只有已驗證電子郵件地址的帳戶才能參加。請驗證您的電子郵件地址後再試一次。",
        "failed": "發生錯誤，請再試一次。"
      },
      "conditions": {
        "title": "參加條款",
        "accept": "我已閱讀並接受參加條款。",
        "confirmedAccount": "只有已驗證電子郵件地址的帳戶才能參加，每個帳戶限參加一次。",
        "noMaintainers": "Fleetyards 維護者不能參加。",
        "publicEntrants": "您的使用者名稱將作為參加者公開顯示在此頁面上。",
        "publicWinner": "如果您得獎，您的使用者名稱將作為得獎者公開顯示。",
        "drawOrder": "抽獎截止後，所有符合資格的參加者將被隨機排成一個順序。排在第一位的參加者得獎。",
        "claimMail": "得獎者將收到一封包含領取獎品連結的郵件。獎品絕不會在本網站上顯示。",
        "claimDeadline": "得獎者需在 %{days} 天內點擊該連結。如未按時點擊，得獎資格將順延給下一位，下一位將收到自己的郵件。",
        "prizeMail": "點擊該連結後，禮品碼將透過郵件寄送到得獎帳戶的電子郵件地址。",
        "deletedAccount": "輪到時帳戶不再處於已驗證狀態的參加者將被跳過。如果你刪除了帳戶，你的參加紀錄會保留，中獎通知將寄送到你參加時使用的電子郵件地址。",
        "noCash": "獎品僅為禮品碼，不提供現金替代，也不可兌換為其他獎品。",
        "noLiability": "Fleetyards 不對禮品碼、其有效性或兌換承擔責任，也不對您的 RSI 帳戶發生的任何問題承擔責任。",
        "noRecourse": "抽獎結果為最終結果，不得透過法律途徑追訴。",
        "notAffiliated": "Fleetyards 是非官方粉絲網站，與 Cloud Imperium Games 無任何關聯。",
        "version": "條款版本 %{version}"
      },
      "claim": {
        "title": "領取獎品",
        "pending": "正在領取您的獎品…",
        "success": "您已領取「%{raffle}」中的獎品。禮品碼正在寄送到您的信箱。",
        "failedTitle": "無法領取獎品",
        "failed": "發生錯誤，請重新開啟該連結。"
      },
      "meta": "%{date} 截止 · %{count} 位參加者",
      "metaClosed": "已於 %{date} 截止 · %{count} 位參加者",
      "showImage": "顯示圖片 %{index}",
      "howItWorks": {
        "title": "參加方式",
        "enter": {
          "title": "%{date} 前參加",
          "text": "接受參加條款即可參加。抽獎截止前，您可以隨時退出。"
        },
        "draw": {
          "title": "抽獎",
          "text": "截止後，所有參加者將被隨機排成一個順序。排在第一位的參加者得獎。"
        },
        "claim": {
          "title": "%{days} 天內領取",
          "text": "得獎者將收到一封包含領取連結的郵件。如 %{days} 天內未點擊，下一位將收到自己的郵件。"
        },
        "code": {
          "title": "禮品碼透過郵件寄送",
          "text": "點擊該連結後，禮品碼將透過郵件寄送。禮品碼絕不會在本網站上顯示。"
        }
      },
      "entry": {
        "prize": "獎品",
        "title": "參加抽獎",
        "yours": "您的參加",
        "closes": "截止",
        "closed": "已截止",
        "claimPeriod": "領取期限",
        "days": "%{days} 天",
        "entered": "您已參加。抽獎將在 %{date} 後進行。",
        "enteredHint": "如果您得獎，我們將寄給您領取連結。抽獎後 %{days} 天內請留意您的信箱。",
        "over": "抽獎已結束",
        "opensAt": "%{date} 開始。",
        "maintainer": "維護者負責管理抽獎，不能參加。",
        "emailRequired": "請先為帳戶新增電子郵件地址再參加。獎品以郵件寄送，而你的帳戶還沒有電子郵件地址。",
        "emailMissing": "你的帳戶沒有電子郵件地址，獎品無法送達，你的參加將在抽獎時被略過。請在 %{date} 前新增一個。"
      },
      "slider": {
        "label": "圖片輪播",
        "previous": "上一張圖片",
        "next": "下一張圖片"
      },
      "home": {
        "view": "查看抽獎",
        "panelTitle": "抽獎",
        "entered": "已參加",
        "notEntered": "您尚未參加。",
        "enter": "參加",
        "pillTag": "抽獎",
        "endsIn": {
          "one": "%{count} 天後結束",
          "other": "%{count} 天後結束"
        },
        "endsToday": "今天結束"
      },
      "mine": {
        "raffle": "抽獎",
        "enteredAt": "參加時間",
        "outcome": "結果",
        "claimBy": "請查收郵件並在 %{date} 前領取",
        "outcomes": {
          "open": "進行中",
          "waiting": "等待開獎",
          "won": "已得獎",
          "claimed": "已領取",
          "forfeited": "未按時領取",
          "not_won": "未得獎"
        }
      },
      "preview": {
        "title": "預覽",
        "text": "你正在透過預覽連結檢視此抽獎。在發布之前，只有持有該連結的人才能看到它。"
      }
    }
  }
}
